import { connectAutocomplete } from '../../../../../dist/vendor/instantsearch.js/es/connectors/index.js';
import {
	parseTemplate,
	encodePostTitle,
	handleKeypress,
	transformOrigin,
} from '../util/helpers.js';
import { createUrl } from '../util/routing.js';
// import {
	// querySuggestionsCategoryPlugin,
	// querySuggestionsPlugin,
	// recentSearchesPlugin
	// } from './plugins.js';
import { opts, searchParam } from '../opts.js';
import {
	setUiState,
	getUiState
} from '../util/state.js';


export const config = {
	...opts.autocomplete,
}

// works as a TransformItems
const renderedHits = (hits, cssClasses) => hits.map((hit, hitIndex) => {
	const permalink = transformOrigin(hit.url);

	const filename =  permalink.replace(/^.*[\\/]/, '');

	const encoded_title = hit.post_title.length < 2 ? filename : hit.post_title;

	return renderIndexListItem({
		hitIndex,
		...hit,
		...cssClasses,
		post_title: encoded_title,
		permalink,
		classes: (hitIndex
			? [cssClasses.item]
			: [cssClasses.item, cssClasses.active]
		).join(''),
	});
}).join('');

// on first render
const firstRender = (refine, renderOptions) => {
	const {
		currentRefinement,
		createURL,
		widgetParams: { container, cssClasses }
	} = renderOptions;

	container.innerHTML = parseTemplate('autocomplete', {
		...config,
		...cssClasses,
		name: searchParam,
	});

	const input = container.querySelector(`.${cssClasses.main}`);
	input.addEventListener('input', () => refine(input.value));
	input.value = currentRefinement;

	return input;
}

const render = (renderOptions, isFirstRender) => {

	const {
		indices,
		currentRefinement,
		refine,
		createURL,
		widgetParams,
	} = renderOptions;

	const {
		container,
		cssClasses,
	} = widgetParams;

	const input = isFirstRender
		? firstRender(refine, renderOptions)
		: container.querySelector(`.${cssClasses.main}`);

	if (isFirstRender) {
		document.addEventListener('keydown',
			e => onKeyUp(e, container, cssClasses, refine));
		input.value = currentRefinement;
	}

	parseIndices(indices, widgetParams)
		.map(index => populate({ ...index, ...renderOptions, input }));
}

const allowPopulate = input => input.value.length >= opts.autocomplete.respondAtThisMany;

const populateShadow = ({ shadow, firstHit, input }) => {
	const matches = input.value.localeCompare(
		firstHit.post_title.slice(0, input.value.length),
		'en',
		{
			sensitivity: 'base'
		});

	// localeCompare: 0 means good match.
	shadow.innerHTML =
		(matches === 0 && allowPopulate(input))
		? wrapChars(firstHit, input)
		: '';
}

const populate = options => {
	const { rendered, firstHit, container, cssClasses, input } = options;
	const shadow = container.querySelector(`.${cssClasses.shadow}`);
	const list = container.querySelector(`.${cssClasses.list}`);

	if (!firstHit?.post_title || !shadow) {
		return;
	}

	firstHit && populateShadow({ ...options, shadow});

	if (list) {
		list.innerHTML = rendered ? rendered : '';
	}
}


export const autocompleteContainer = parseTemplate('autocomplete', {
	...config,
	name:  searchParam,
});


const wrapChars = ({ post_title }, input) => [...post_title].map((char, i) => {
	const classes = i < input.value.length ? 'char-hidden' : 'char';
	const val = i < input.value.length ? input.value[i] : char;
	return `<span class="${classes}">${val}</span>`
}).join('');


const parseIndices = (indices, { container, cssClasses }) =>
	indices.map(index => ({
			...index,
			container,
			cssClasses,
			rendered: renderedHits(index.hits, cssClasses),
			firstHit: index.hits ? index.hits[0] : false
		}));


const onKeyUp = (event, container, cssClasses, refine) => [
		9,       // tab
		13,      // enter
		'Enter',
		38,      // ups
		40       // downses,
		// 39 // right
	].includes(event.keyCode) &&
		handleKeypress(event, container, cssClasses, refine);


const renderIndexListItem = item => parseTemplate('autocomplete-result', item );

export const widget = connectAutocomplete(render);

export function startAutocomplete(instance) {

	let skip = false;
	const uiState = getUiState();

	const { setQuery } = autocompleteWidget({
		...config,
		navigator: { navigate() {} },
		plugins: [
			// recentSearchesPlugin,
			// querySuggestionsCategoryPlugin,
			// querySuggestionsPlugin
		],
		openOnFocus: true,
		detachedMediaQuery: 'none',
		escapeHTML: true,
		initialState: {
			query: uiState[searchParam] || '',
		},
		onSubmit({ state }) {

			setUiState({
				[searchParam]: state[searchParam]
			});
		},
		onReset() {
			setUiState({ [searchParam]: '' });
		},
		onStateChange({ prevState, state }) {
			if (!skip && prevState[searchParam] !== state[searchParam]) {
				debouncedUiState({
					[searchParam]: state[searchParam]
				});
			}

			skip = false;
		},
	});

	// sets state as url changes
	setQuery && window.addEventListener('popstate', () => {
		skip = true;
		setQuery(
			(instance.helper && instance.helper.state[searchParam])
			|| ''
		);
	});
}

